var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowBackDouble = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "arrow-back-double_svg__icon arrow-back-double_svg__icon-tabler arrow-back-double_svg__icons-tabler-outline arrow-back-double_svg__icon-tabler-arrow-back-up-double",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "none",
  d: "M0 0h24v24H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m13 14-4-4 4-4M8 14l-4-4 4-4"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M9 10h7a4 4 0 1 1 0 8h-1"
})));
export default SvgArrowBackDouble;